<template>
  <div class="form__group">
    <input
      ref="customInput"
      :type="type"
      :value="value"
      class="form__input"
      :placeholder="label"
      required
      :disabled="mode"
      :class="{ disabled: disabled }"
      @input="emitInput"
      @keydown.esc="$emit('close')"
    />
    <label v-if="!disabled" for="name" class="form__label">{{ label }}</label>
  </div>
</template>

<script>
export default {
  props: ["type", "label", "value", "mode", "disabled"],
  emits: ["input", "close"],
  data() {
    return {};
  },
  mounted() {
    this.$refs.customInput.focus();
  },
  methods: {
    emitInput(event) {
      // Emit the input event to notify the parent about changes
      this.$emit("input", event.target.value);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/styles/variables.less";

.disabled:disabled {
  border-radius: @kk-border-radius;
  padding: 0.5rem 0.3rem;
  border: thin solid @kk-color-gray-1;
  text-align: right;
}

.form {
  &__group {
    display: flex;
    flex-direction: column;
    align-items: start;
  }

  &__input {
    font-size: 1rem;
    font-family: inherit;
    color: inherit;
    padding: 0.3rem 0.3rem;
    border: none;
    border-bottom: thin solid @kk-color-primary-blue;
    width: 100%;
    display: block;
    transition: all 0.3s;

    &:disabled {
      background-color: @kk-color-light-gray;
      color: @kk-color-gray;
      pointer-events: none;
    }

    &:focus {
      outline: none;
      border-bottom: thin solid @kk-btn-info-color;
    }

    &:focus:invalid {
      border-bottom: thin solid @kk-color-gold;
    }

    &::-webkit-input-placeholder {
      color: @color-grey-dark-2;
    }
  }

  &__label {
    font-size: 0.8rem;
    font-weight: 700;
    margin-top: 0.2rem;
    display: block;
    transition: all 0.3s;
  }

  &__input:placeholder-shown + &__label {
    opacity: 0;
    visibility: hidden;
    transform: translateY(-2rem);
  }
}
</style>
